import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    container: css({
        width: '100%',
    }),
    inputWrapper: css({
        display: 'flex',
        flexDirection: 'row',
        gap: '20px',
        alignItems: 'flex-start',
    }),
    select: css({
        '.css-1bpd5ux-MuiInputBase-root-MuiInput-root-MuiSelect-root-select': {
            flex: 1,
        },
        '.MuiSelect-select': {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
        },
    }),
    input: css({
        '.MuiFormHelperText-root': {
            color: theme.palette.primary.main,
        },
    }),
    link: css({
        '& a': {
            color: theme.palette.primary.main,
            textDecoration: 'underline',
        },
    }),
};
